/** Type of error thrown when a `fetch` response is non-OK */
export class ApiError extends Error {
  constructor(public response: Response) {
    super("ApiError");
  }
}
